export function removeArticles(texto: string) {
  const artigos = ["da", "de", "do"];
  const palavras = texto.split(" ");
  const palavrasSemArtigos = palavras.filter(palavra => !artigos.includes(palavra.toLowerCase()));
  const novoTexto = palavrasSemArtigos.join(" ");
  return novoTexto;
}